<app-toolbar></app-toolbar>
<div [@routeAnimations]="getRouteAnimationData()">
  <router-outlet *ngIf="!isIframe()"></router-outlet>
</div>
